'use client';

import { Icon } from '@galapagos/design-system/web';
import { sizing } from '@galapagos/design-system/sizing';
import { ensureSignupStepStyle } from './signup-step-style';

/** v7 Web/Privacy note: a small reassurance line with a lock. Text, not a control. */
export function PrivacyNote({ text }: { text: string }) {
  ensureSignupStepStyle();
  return (
    <p className="signup-privacy-note">
      <Icon name="lock" size={sizing.icon.xs} tone="secondary" aria-hidden />
      <span>{text}</span>
    </p>
  );
}
